import React from "react";
import { TextField } from "@mui/material";
import { Controller } from "react-hook-form";
import { Height } from "@mui/icons-material";

type Props = {
  type?: "text" | "email" | "password" | "number";
  name: string;
  label: string;
  multiline?: boolean;
  rows?: number;
  disabled?: boolean;
  key?: string;
  changeHandler?: (e:any) => void;
  control: any;
  step?: number;
  min?: number;
  max?: number;
  height?: number;
};

function FieldInputText(props: Props) {
  const { type = "text", name, label, control, disabled, changeHandler, step = 1, min, max, height, rows, multiline} = props;
  let input: any = {}
  let htmlInput: any = {}
  height && (input = { 
    style: { height }
  })
  type === 'number' && (htmlInput = {
    step,
    min,
    max
  })

  return (
    <Controller
      name={name}
      control={control}
      render={({ field: { onChange, value }, fieldState: { error } }) => {
        return (
          <TextField
            type={type}
            onChange={(e) => {
              changeHandler && changeHandler(e);
              onChange(e);
            }}
            //defaultValue={value || ''}
            value={value || (type === 'number' ? 0 : '')}
            label={label}
            size="small"
            helperText={`${error?.message ? error?.message : ""}`}
            error={!!error}
            disabled={disabled}
            fullWidth
            rows={rows}
            multiline={multiline}
            slotProps={{
              htmlInput,
              input
            }}
          />
        );
      }}
    />
  );
}

export default FieldInputText;
